<template>
  <div>
    <v-card-title>
      <v-row>
        <v-col cols="3"
          ><h1>{{ $t("invoice.title") }}</h1></v-col
        >
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-text-field v-model="search" append-icon="search" :label="$t('global.search')" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
    </v-card-title>

    <v-data-table :headers="headers" :items="invoices" :loading="$store.getters['Ajax/loading'] ? 'accent' : false">
      <template #item="props">
        <tr>
          <td class="">
            {{ props.item.number }}
            <v-chip small v-if="props.item.left_to_pay === 0" label outlined style="color: #44d3af; background-color: rgba(30,255,200,0.22) !important;"
              >{{ $t("invoice.paid") }}
            </v-chip>
          </td>
          <td class="text-left">{{ props.item.net_in_currency }} {{ props.item.currency_symbol }}</td>
          <td class="text-left accent--text" style="font-weight: bold">
            {{ props.item.gross_in_currency }}
            {{ props.item.currency_symbol }}
          </td>
          <td class="text-left">{{ props.item.issue_date }}</td>
          <td class="text-left">{{ props.item.sale_date }}</td>
          <td class="text-left " style="font-weight: 900">
            {{ props.item.left_to_pay }}
            {{ props.item.currency_symbol }}
          </td>
          <td class="text-left">
            {{ $t("invoice.paymentType." + props.item.form_of_payment_name.toLowerCase()) }}
          </td>
          <td>
            <v-tooltip bottom>
              {{ $t("invoice.showDetails") }}
              <template #activator="{on}">
                <v-btn v-on="on" icon class="mx-0" :to="'/invoices/details/' + props.item.id">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("invoice.download") }}
              <template #activator="{on}">
                <v-btn v-on="on" icon class="mx-0" @click="downloadInvoice(props.item)" :title="$t('invoice.download')">
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "InvoicesView",
  data: () => ({
    search: ""
  }),
  computed: {
    invoices() {
      return this.$store.getters["Invoice/invoiceList"];
    },
    headers() {
      return [
        { text: this.$t("invoice.dataTableHeaders.number"), value: "number" },
        {
          text: this.$t("invoice.dataTableHeaders.net"),
          value: "net_in_currency"
        },
        {
          text: this.$t("invoice.dataTableHeaders.gross"),
          value: "gross_in_currency"
        },
        {
          text: this.$t("invoice.dataTableHeaders.issueDate"),
          value: "issue_date"
        },
        {
          text: this.$t("invoice.dataTableHeaders.sellDate"),
          value: "sale_date"
        },
        {
          text: this.$t("invoice.dataTableHeaders.leftToPay"),
          value: "left_to_pay"
        },
        {
          text: this.$t("invoice.dataTableHeaders.formOfPayment"),
          value: "form_of_payment_name"
        },
        { text: "", value: "actions", sortable: false }
      ];
    }
  },
  methods: {
    downloadInvoice(invoice) {
      this.$store.dispatch("Invoice/downloadInvoiceFile", invoice);
    }
  },
  created() {
    this.$store.dispatch("Invoice/loadAllInvoices");
  }
};
</script>

<style scoped>
table.table thead td:not(:nth-child(1)),
table.table tbody td:not(:nth-child(1)),
table.table thead th:not(:nth-child(1)),
table.table tbody th:not(:nth-child(1)),
table.table thead td:first-child,
table.table tbody td:first-child,
table.table thead th:first-child,
table.table tbody th:first-child {
  padding: 0 15px;
}
</style>
